import type { DTOApplicationFormReturn } from "types/Card";

/**
 * Creates statement of health payload for Redux store
 */
export const createStatementOfHealthPayload = (statementOfHealth: any) => {
    if (!statementOfHealth || !statementOfHealth.height) {
        return null;
    }

    return {
        heightFeet: statementOfHealth.height.feet,
        heightInches: statementOfHealth.height.inches,
        weight: statementOfHealth.weight,
        hasUsedNicotine: statementOfHealth.hasUsedNicotine,
        hasMedicalConditions: statementOfHealth.hasMedicalConditions,
        hasDiagnosticTesting: statementOfHealth.hasDiagnosticTesting,
    };
};

/**
 * Restores statement of health form data from Redux
 */
export const restoreStatementOfHealthData = (statementOfHealthData: any, setValue: DTOApplicationFormReturn["setValue"]) => {
    if (!statementOfHealthData) {
        return;
    }

    setValue("statementOfHealth.height.feet", statementOfHealthData?.heightFeet);
    setValue("statementOfHealth.height.inches", statementOfHealthData?.heightInches);
    setValue("statementOfHealth.weight", statementOfHealthData?.weight);
    setValue("statementOfHealth.hasMedicalConditions", statementOfHealthData?.hasMedicalConditions ?? null);
    setValue("statementOfHealth.hasDiagnosticTesting", statementOfHealthData?.hasDiagnosticTesting ?? null);
};

/**
 * Extracts statement of health values from form
 */
export const extractStatementOfHealthValues = (formData: any, hasUsedNicotineLastYear: boolean) => {
    return {
        heightFeet: formData.height.feet,
        heightInches: formData.height.inches,
        weight: formData.weight,
        hasUsedNicotine: hasUsedNicotineLastYear,
        hasMedicalConditions: formData.hasMedicalConditions,
        hasDiagnosticTesting: formData.hasDiagnosticTesting,
    };
};
